export default __webpack_public_path__ + "static/media/pdf.8b6ef697.svg";